/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import * as MsDyn365 from '@msdyn365-commerce/core';
import { Node } from '@msdyn365-commerce-modules/utilities';
import { ISzfContactUsViewProps } from './szf-contact-us';
import {
    Form,
    Input,
    FormGroup,
    Label,
    Button,
    FormFeedback,
    // Spinner,
    InputGroup,
    // InputGroup
} from 'reactstrap';
import { MoonLoader } from 'react-spinners';
import contactFormDataAction, { PostContactUsFormInput } from './../../actions/post-contact-us-form.action';

import getInqueryOptionsDataAction, { GetInqueryOptionsInput } from './../../actions/get-inquery-options.action';
import existingContactDataAction, { GetExistingContactInput } from './../../actions/get-existing-contact.action';
import createNewContactDataAction, { PostNewContactInput } from './../../actions/post-new-contact.action';
import SZFModal from '../../utilities/szf-modal.component';
import PhoneInput from 'react-phone-input-2';
import arabicLocale from 'react-phone-input-2/lang/ar.json';
export interface IPostContactUsFormInput {
    Inquiry: string;
    InquiryInvalid: boolean;
    description: string;
    descriptionInvalid: boolean;
    email: string;
    emailInvalid: boolean;
    firstName: string;
    firstNameInvalid: boolean;
    lastName: string;
    lastNameInvalid: boolean;
    phone: string;
    countryCode: string;
    phoneInvalid: boolean;
    fileInvalid: boolean;
    // termNcondition: boolean;
    updateNpromotion: boolean;
}
export interface INewContactCreation {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    countryCode: string;
    updateNpromotion: boolean;
}
export interface IcountryCodeInput {
    countryCode: string;
    dialCode: string;
    format: string;
    name: string;
}
export interface IInqueryOptions {
    szf_casetypeid: string;
    szf_name: string;
}

export default (props: ISzfContactUsViewProps) => {
    const [loading, setLoading] = React.useState(false);
    const [state, setState] = React.useState<IPostContactUsFormInput>({
        firstName: '',
        firstNameInvalid: false,
        lastName: '',
        lastNameInvalid: false,
        email: '',
        emailInvalid: false,
        phone: '',
        countryCode: '',
        phoneInvalid: false,
        Inquiry: '',
        InquiryInvalid: false,
        description: '',
        descriptionInvalid: false,
        fileInvalid: false,
        // termNcondition: false,
        updateNpromotion: false,
    });
    const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);
    const [contactUsError, setContactUsError] = React.useState('');
    const fileRef = React.useRef<HTMLInputElement>(null);
    const [inquiryOptionsData, setInquiryOptionsData] = React.useState<(IInqueryOptions | null)[]>();
    const [file, setFile] = React.useState<File | undefined>();
    const [fileBase64Code, setFileBase64Code] = React.useState<string | ArrayBuffer | null>();
    const inquiryOptions = props.config.inquiryOptions;
    const locale = props.context.request.locale;
    // const termAndConditionCheckboxLabel = props.config.termAndConditionCheckboxLabel;
    const updateAndPromotionCheckboxLabel = props.config.updateAndPromotionCheckboxLabel;
    const successImageProps = {
        gridSettings: props.context.request.gridSettings ?? {},
        imageSettings: props.config.successModalImage?.imageSettings,
    };
    const failureImageProps = {
        gridSettings: props.context.request.gridSettings ?? {},
        imageSettings: props.config.failModalImage?.imageSettings,
    };
    const imageContainer = { className: 'ms-content-block__image' };
    const successImage = (
        <Node {...imageContainer}>
            <MsDyn365.Image
                {...props.config.successModalImage}
                {...successImageProps}
                requestContext={props.context.request}
                preserveImageSpace={true}
                editProps={{
                    key: props.config.successModalImage ?? {},
                    requestContext: props.context.request,
                    moduleType: props.typeName,
                    imagePropertyName: 'image',
                    moduleId: props.id,
                }}
                shouldSkipToMainImage
            />
        </Node>
    );
    const failureImage = (
        <Node {...imageContainer}>
            <MsDyn365.Image
                {...props.config.failModalImage}
                {...failureImageProps}
                requestContext={props.context.request}
                preserveImageSpace={true}
                editProps={{
                    key: props.config.failModalImage ?? {},
                    requestContext: props.context.request,
                    moduleType: props.typeName,
                    imagePropertyName: 'image',
                    moduleId: props.id,
                }}
                shouldSkipToMainImage
            />
        </Node>
    );

    // const cuCountryCodeOptions = props.config.cuCountryCodeOptions;
    const {
        firstnameLabel,
        lastnameLabel,
        emailLabel,
        phoneLabel,
        inquirySelectLabel,
        descriptionLabel,
        fileLabel,
        submitButtonLabel,
    } = props.config;
    const {
        genericErrorMessage,
        invalidOrEmptyFieldError,
        dropdownChooseOptionMessage,
        maxFileSize,
        fileInvalidMessage,
        szfSuccessModalHeading,
        szfSuccessModalMessage,
        szfFailModalHeading,
        descriptionInvalidMessage,
    } = props.resources;
    const fileSize = props.config.fileSize || 20;
    const fileSizeKB = fileSize * 1024;
    const handleUpdateAndPromotionLabelChange = (event: MsDyn365.ContentEditableEvent) =>
        (props.config.updateAndPromotionCheckboxLabel = event.target.value);
    // const handleTermAndConditionLabelChange = (event: MsDyn365.ContentEditableEvent) => (props.config.termAndConditionCheckboxLabel = event.target.value);
    const updateAndPromotionLabel = updateAndPromotionCheckboxLabel && (
        <MsDyn365.RichTextComponent
            text={updateAndPromotionCheckboxLabel}
            editProps={{ onEdit: handleUpdateAndPromotionLabelChange, requestContext: props.context.request }}
        />
    );
    // const termAndConditionCheckboxText = termAndConditionCheckboxLabel && (
    //     <MsDyn365.RichTextComponent
    //         text={termAndConditionCheckboxLabel}
    //         editProps={{ onEdit: handleTermAndConditionLabelChange, requestContext: props.context.request }}
    //     />
    // );
    const fetchInqueryOptions = React.useCallback(async () => {
        try {
            const CRMtoken = (await props.data.crmToken)?.token || undefined;
            const input = new GetInqueryOptionsInput(CRMtoken);
            const result = await getInqueryOptionsDataAction(input, props.context.actionContext);
            const inquiryOptionsLowercase = inquiryOptions?.map((item) => {
                return item.toLowerCase();
            });
            if (result.data && result.data.length > 0) {
                const filteredResult: (IInqueryOptions | null)[] = result.data
                    .map((item) => {
                        if (locale.toLowerCase() === 'ar-ae') {
                            if (inquiryOptionsLowercase?.includes(item.szf_arabic.toLowerCase())) {
                                return {
                                    szf_casetypeid: item.szf_casetypeid,
                                    szf_name: item.szf_arabic,
                                };
                            } else {
                                return null;
                            }
                        } else {
                            if (inquiryOptionsLowercase?.includes(item.szf_name.toLowerCase())) {
                                return {
                                    szf_casetypeid: item.szf_casetypeid,
                                    szf_name: item.szf_name,
                                };
                            } else {
                                return null;
                            }
                        }
                    })
                    .filter((i) => i);
                setInquiryOptionsData(filteredResult);
            }
        }catch(error){
            console.log(error);
        }
    }, []);
    React.useEffect(() => {
        fetchInqueryOptions();
    }, []);
    const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const name: string = e.target.name;
        const value = e.target.value;

        if (name === 'email') {
            const emailPattern: RegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
            if (emailPattern.test(value)) {
                const obj = { ...state, [name]: value, emailInvalid: false };
                setState(obj);
            } else {
                const obj = { ...state, [name]: value, emailInvalid: true };
                setState(obj);
            }
        } else if (name === 'phone') {
            const obj = { ...state, [name]: value, phoneInvalid: false };
            setState(obj);
        } else {
            const obj = { ...state, [name]: value };
            setState(obj);
        }
    };
    const getbase64 = (imagefile: File) => {
        const reader = new FileReader();
        reader.readAsDataURL(imagefile);
        reader.onload = () => {
            const result = reader.result;
            const base64 = result?.toString().split('base64,');
            setFileBase64Code(base64 && base64[1]);
        };
    };
    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            if (e.target.files[0] && e.target.files[0].size / 1024 > fileSizeKB) {
                setState({ ...state, fileInvalid: true });
            } else {
                setState({ ...state, fileInvalid: false });
                const imagefile = e.target.files[0];
                if (imagefile) {
                    getbase64(imagefile);
                    setFile(imagefile);
                }
            }
        }
    };
    const handleCheckboxChange = (e: any) => {
        const name: string = e.target.name;
        setState({ ...state, [name]: !state.updateNpromotion });
    };
    const checkExistingContact = async (token: string, email: string, phone: string) => {
        const contactExistInput = new GetExistingContactInput(token, email, phone);
        const result = await existingContactDataAction(contactExistInput, props.context.actionContext);
        return result;
    };
    const resetFileField = () => {
        setState({
            ...state,
            fileInvalid: false,
        });
        if (fileRef.current && fileRef.current.value) {
            fileRef.current.value = '';
        }
        setFile(undefined);
        setFileBase64Code(null);
    };
    const resetForm = () => {
        setState({
            firstName: '',
            firstNameInvalid: false,
            lastName: '',
            lastNameInvalid: false,
            email: '',
            emailInvalid: false,
            phone: '',
            countryCode: '971',
            phoneInvalid: false,
            Inquiry: '',
            InquiryInvalid: false,
            description: '',
            descriptionInvalid: false,
            fileInvalid: false,
            // termNcondition: false,
            updateNpromotion: false,
        });

        if (fileRef.current && fileRef.current.value) {
            fileRef.current.value = '';
        }
        setFile(undefined);
        setFileBase64Code(null);
        setContactUsError('');
    };
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };
    const onSubmitForm = async (e: any): Promise<void> => {
        e.preventDefault();
        const emailPattern: RegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        if (state.firstName.length <= 0) {
            setState({ ...state, firstNameInvalid: true });
            setLoading(false);
            document.getElementById('firstName')?.focus();
            return;
        } else if (state.lastName.length <= 0) {
            setState({
                ...state,
                firstNameInvalid: false,
                lastNameInvalid: true,
            });
            setLoading(false);
            document.getElementById('lastName')?.focus();
            return;
        } else if (state.email.length <= 0 || !emailPattern.test(state.email)) {
            setState({
                ...state,
                firstNameInvalid: false,
                lastNameInvalid: false,
                emailInvalid: true,
            });
            setLoading(false);
            document.getElementById('email')?.focus();
            return;
        } else if (!state.phone || state.phone.length < 4 || state.phone.length > 20) {
            setState({
                ...state,
                firstNameInvalid: false,
                lastNameInvalid: false,
                phoneInvalid: true,
            });
            setLoading(false);
            document.getElementById('phone')?.focus();
            return;
        } else if (state.Inquiry.length <= 0) {
            setState({
                ...state,
                firstNameInvalid: false,
                lastNameInvalid: false,
                emailInvalid: false,
                phoneInvalid: false,
                InquiryInvalid: true,
            });
            setLoading(false);
            document.getElementById('Inquiry')?.focus();
            return;
        } else if (state.description.length <= 0 || state.description.length >= 300) {
            setState({
                ...state,
                firstNameInvalid: false,
                lastNameInvalid: false,
                emailInvalid: false,
                phoneInvalid: false,
                InquiryInvalid: false,
                descriptionInvalid: true,
            });
            setLoading(false);
            document.getElementById('description')?.focus();
            return;
        } else if (file && file?.size && file.size / 1024 > fileSizeKB) {
            setState({
                ...state,
                firstNameInvalid: false,
                lastNameInvalid: false,
                emailInvalid: false,
                phoneInvalid: false,
                InquiryInvalid: false,
                descriptionInvalid: false,
                fileInvalid: true,
            });
            setLoading(false);
            fileRef?.current?.focus();
            return;
        } else {
            setState({
                ...state,
                firstNameInvalid: false,
                lastNameInvalid: false,
                emailInvalid: false,
                phoneInvalid: false,
                InquiryInvalid: false,
                descriptionInvalid: false,
                fileInvalid: false,
            });
        }
        const mergePhoneWithCountryCode = `${state.countryCode}${state.phone}`;
        try {
            const CRMtoken = (await props.data.crmToken)?.token || undefined;
            const isContactAlreadyExist = await checkExistingContact(CRMtoken, state.email, mergePhoneWithCountryCode);
            if (isContactAlreadyExist.status) {
                const createCaseInput = new PostContactUsFormInput(state, file, fileBase64Code, CRMtoken, isContactAlreadyExist.id);
                const createCaseResponse = await contactFormDataAction(createCaseInput, props.context.actionContext);
                if (createCaseResponse.status) {
                    resetForm();
                    setLoading(false);
                    setIsModalOpen(true);
                } else {
                    setContactUsError(createCaseResponse.msg || genericErrorMessage);
                    setLoading(false);
                    setIsModalOpen(true);
                }
            } else {
                const createInputData: INewContactCreation = {
                    firstName: state.firstName,
                    lastName: state.lastName,
                    email: state.email,
                    phone: `${state.phone}`,
                    countryCode: `${state.countryCode}`,
                    updateNpromotion: state.updateNpromotion,
                };
                const createContactInput = new PostNewContactInput(CRMtoken, createInputData);
                const createNewContactResponse = await createNewContactDataAction(createContactInput, props.context.actionContext);
                if (createNewContactResponse.status) {
                    const createCaseInput = new PostContactUsFormInput(state, file, fileBase64Code, CRMtoken, createNewContactResponse.id);
                    const createCaseResponse = await contactFormDataAction(createCaseInput, props.context.actionContext);
                    if (createCaseResponse.status) {
                        resetForm();
                        setLoading(false);
                        setIsModalOpen(true);
                    } else {
                        setLoading(false);
                        setContactUsError(createCaseResponse?.msg || genericErrorMessage);
                        setIsModalOpen(true);
                    }
                } else {
                    setLoading(false);
                    setContactUsError(createNewContactResponse.msg ? createNewContactResponse.msg : genericErrorMessage);
                    setIsModalOpen(true);
                }
            }
            setLoading(false);
        } catch (error) {
            setContactUsError(genericErrorMessage);
            setLoading(false);
            setIsModalOpen(true);
            console.log('error', error);
        }
    };
    const handlePhoneCountryCodeOnChange = (value: string, country: IcountryCodeInput) => {
        const numberWithoutCountryCode = value.toString().split(`${country.dialCode}`);
        setState({
            ...state,
            phone: numberWithoutCountryCode[1],
            countryCode: country.dialCode,
        });
    };
    return (
        <>
            <div className='contact-left'>
                <p>{props.resources.contactUsParagraph}</p>
                <SZFModal
                    isOpen={isModalOpen}
                    onModalToggle={toggleModal}
                    className={'status-modal'}
                    modalTitle={
                        <>
                            <h3>{contactUsError ? szfFailModalHeading : szfSuccessModalHeading}</h3>
                            <button onClick={toggleModal} className='modal-close-btn'>
                                <img
                                    src='https://images-ap-prod.cms.commerce.dynamics.com/cms/api/rwrswxpkjb/imageFileData/MB2jbv?pubver=0'
                                    alt=''
                                />
                            </button>
                        </>
                    }
                    modalBody={
                        isModalOpen ? (
                            <div className='szf-modal-body'>
                                {contactUsError ? failureImage : successImage}
                                <h4>{contactUsError ? contactUsError : szfSuccessModalMessage}</h4>
                            </div>
                        ) : null
                    }
                />
                <Form onSubmit={onSubmitForm}>
                    <FormGroup floating className="form-floating">
                        <Input
                            type='text'
                            name='firstName'
                            id='firstName'
                            placeholder='First Name*'
                            value={state.firstName}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                onChangeHandler(event);
                            }}
                            className='form-control'
                            invalid={state.firstNameInvalid}
                            required
                        />
                        <Label for='firstName'>{firstnameLabel && firstnameLabel}</Label>
                        <FormFeedback>{invalidOrEmptyFieldError && invalidOrEmptyFieldError}</FormFeedback>
                    </FormGroup>
                    <FormGroup floating className="form-floating">
                        <Input
                            type='text'
                            name='lastName'
                            id='lastName'
                            placeholder='Last Name*'
                            value={state.lastName}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                onChangeHandler(event);
                            }}
                            className='form-control'
                            invalid={state.lastNameInvalid}
                            required
                        />
                        <Label for='lastName'>{lastnameLabel && lastnameLabel}</Label>
                        <FormFeedback>{invalidOrEmptyFieldError && invalidOrEmptyFieldError}</FormFeedback>
                    </FormGroup>
                    <FormGroup floating className="form-floating">
                        <Input
                            type='email'
                            name='email'
                            id='email'
                            placeholder='Email'
                            value={state.email}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                onChangeHandler(event);
                            }}
                            className='form-control'
                            required
                            invalid={state.emailInvalid}
                        />
                        <Label for='email'>{emailLabel && emailLabel}</Label>
                        <FormFeedback>{invalidOrEmptyFieldError && invalidOrEmptyFieldError}</FormFeedback>
                    </FormGroup>
                    <div className='phone-group'>
                        {' '}
                        <Label for='phone'>{phoneLabel && phoneLabel}</Label>
                        {locale.toLowerCase() === 'ar-ae' ? (
                            <PhoneInput
                                inputProps={{
                                    id: `phone`,
                                    name: 'phone',
                                    required: true,
                                    placeholder: `+971 5# ### ###`
                                }}
                                country={'ae'}
                                enableAreaCodes={true}
                                localization={arabicLocale}
                                inputClass={state.phoneInvalid ? 'invalidphone' : ''}
                                value={`${state.countryCode}${state.phone}`}
                                autoFormat={true}
                                enableSearch={true}
                                onChange={handlePhoneCountryCodeOnChange}
                            />
                        ) : (
                            <PhoneInput
                                inputProps={{
                                    id: `phone`,
                                    name: 'phone',
                                    required: true,
                                    placeholder: `+971 5# ### ###`
                                }}
                                country={'ae'}
                                enableAreaCodes={true}
                                inputClass={state.phoneInvalid ? 'invalidphone' : ''}
                                value={`${state.countryCode}${state.phone}`}
                                autoFormat={true}
                                enableSearch={true}
                                onChange={handlePhoneCountryCodeOnChange}
                            />
                        )}
                        {state.phoneInvalid && (
                            <div className='invalid-feedback'>
                                {state.phoneInvalid && invalidOrEmptyFieldError && invalidOrEmptyFieldError}
                            </div>
                        )}
                    </div>
                    <FormGroup floating className="form-floating">
                        <Input
                            type='select'
                            name='Inquiry'
                            placeholder='Inquiry'
                            id='Inquiry'
                            value={state.Inquiry}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                onChangeHandler(event);
                            }}
                            className='form-control'
                            invalid={state.InquiryInvalid}
                            required
                        >
                            {inquiryOptions && inquiryOptions.length > 0 && (
                                <option key={`contact-us-Inquiry-options-${0}-first`} value=''>
                                    {dropdownChooseOptionMessage}
                                </option>
                            )}
                            {inquiryOptionsData &&
                                inquiryOptionsData?.map((optionItem, i) => {
                                    return (
                                        <>
                                            <option key={`contact-us-Inquiry-options-${i}`} value={optionItem?.szf_casetypeid}>
                                                {optionItem?.szf_name}
                                            </option>
                                        </>
                                    );
                                })}
                        </Input>
                        <Label for='Inquiry'>{inquirySelectLabel && inquirySelectLabel}</Label>
                        <FormFeedback>{invalidOrEmptyFieldError && invalidOrEmptyFieldError}</FormFeedback>
                    </FormGroup>
                    <FormGroup floating  className='contact-us-textarea form-floating form-floating'>
                        <Input
                            type='textarea'
                            name='description'
                            placeholder='Please share details here...'
                            id='description'
                            value={state.description}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                onChangeHandler(event);
                            }}
                            invalid={state.descriptionInvalid}
                            className='form-control'
                            required
                        />
                        <Label for='description'>{descriptionLabel && descriptionLabel}</Label>
                        <FormFeedback>{descriptionInvalidMessage && descriptionInvalidMessage}</FormFeedback>
                    </FormGroup>
                    <FormGroup floating  className='contact-us-file-formgroup in-contact-page form-floating'>
                        <InputGroup>
                            <Input
                                type='file'
                                innerRef={fileRef}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    handleFileChange(event);
                                }}
                                invalid={state.fileInvalid}
                                className='form-control contact-us-file'
                            />
                            <Button
                                onClick={() => {
                                    resetFileField();
                                }}
                            >
                                x
                            </Button>
                            <Label for='file'>{fileLabel && fileLabel}</Label>
                            {maxFileSize && (
                                <div className='file-size-info'>
                                    <div className='info-icon'>
                                        <img
                                            src='https://images-ap-prod.cms.commerce.dynamics.com/cms/api/rwrswxpkjb/imageFileData/MB2lGx?pubver=0'
                                            alt=''
                                        />
                                    </div>
                                    <p>{maxFileSize}</p>
                                </div>
                            )}
                            <FormFeedback>{fileInvalidMessage && fileInvalidMessage}</FormFeedback>
                        </InputGroup>
                    </FormGroup>
                    <FormGroup check>
                        <Label check className='custom-checkbox'>
                            {updateAndPromotionLabel}
                            <Input
                                type='checkbox'
                                id='updateNpromotion'
                                name='updateNpromotion'
                                defaultChecked={state.updateNpromotion}
                                checked={state.updateNpromotion}
                                onChange={(event: any) => {
                                    handleCheckboxChange(event);
                                }}
                                className='form-control'
                            />
                            <span className='checkmark'></span>
                        </Label>
                    </FormGroup>
                    <Button
                        type='submit'
                        className='btn'
                        onClick={(e: any) => {
                            setLoading(true);
                            onSubmitForm(e);
                        }}
                        disabled={loading}
                    >
                        {loading && (
                            <>
                                <MoonLoader size={15} color='#fff' />
                            </>
                        )}
                        {submitButtonLabel && submitButtonLabel}
                    </Button>
                </Form>
            </div>
        </>
    );
};
